import { Token } from ".";

export const StockTokenConfig: Token[] = [
    { symbol: 'XAUT', address: '0x21cAef8A43163Eea865baeE23b9C2E327696A3bf', decimals: 6 },
    { symbol: 'SKHYB', address: '0xCA750eF65f295BBECd685Abf54e82CAf297BDB61', decimals: 18 },
    { symbol: 'SPYB', address: '0x7138b48df7D98D7e3cc221BfE7192D0a178182D8', decimals: 18 },
    { symbol: 'QQQB', address: '0x205812CdBed920aFf76C6580abD681a46D11efc7', decimals: 18 },
    { symbol: 'NVDAB', address: '0x02Fca66C1D1aFB4E2A7884261eB00F63598a7436', decimals: 18 },
    { symbol: 'SPCXB', address: '0xbe9D156892E55e7154BcD3cB0FEA677F9D3103E1', decimals: 18 },
    { symbol: 'AAPLB', address: '0x431a3BEE82E2ca41e49895CbECE5bB0F76A89b7A', decimals: 18 },
    { symbol: 'TSLAB', address: '0x5b1910eAaD6450E50f816082Aa078C41F10C292f', decimals: 18 },
    { symbol: 'MSFTB', address: '0x80106cb3ead06659a5ad19df39d9b4733863b9b0', decimals: 18 },
    { symbol: 'GOOGLB', address: '0x3F53De71c126BdaBAe20f9cD64848d317f6C3238', decimals: 18 },
    { symbol: 'HOODB', address: '0xA394dCEa3fd3847fD793afBFd163E2e3858B7c65', decimals: 18 },
    { symbol: 'BABAB', address: '0x4eF9d3062c7F6ebA4AAE4990c5036598C6eff4ec', decimals: 18 },
    { symbol: 'GMEB', address: '0x46cEeFDa28Dd7207059ed19B0acdc026955bb15C', decimals: 18 },
    { symbol: 'MSTRB', address: '0xE87afb3076AeB0f9B14E368DE8145ae6a2826A14', decimals: 18 },
    { symbol: 'BNCB', address: '0x4902C5ebc598265Ed2212b559B042De8a5Eeec3f', decimals: 18 },
    { symbol: 'SOXSB', address: '0xE28Cd11C99AF2df76bb8aDA4Cd0ef3904378280F', decimals: 18 },
    { symbol: 'SOXLB', address: '0xd97d097a89113fa59b76c572E5b2Eb647E8eefaf', decimals: 18 },
    { symbol: 'MRNAB', address: '0x5fd86da9B05abE396fe9d02a4A213A7c00556503', decimals: 18 },
    { symbol: 'FLNCB', address: '0x4af1D41cd9dD950dcA43984b43aaA2A8702714Ac', decimals: 18 },
    { symbol: 'BMNRB', address: '0x3548Da95a9eFFE481e8604664d75e95821e557F5', decimals: 18 },
    { symbol: 'FXIon', address: '0x9b8e987e6fec8cf1380c4dca7071e2c7853aeea1', decimals: 18 },
    { symbol: 'BILion', address: '0x91fc7371d6dE682A1e8CFcB4EB7dA693312A03a4', decimals: 18 },
    { symbol: 'SGOV', address: '0xc008c5F579ec1450F20099c39F587547e27c7523', decimals: 18 },
    { symbol: 'TLT', address: '0xf69e40069aC227C11459E3f4e8a446b3401616b6', decimals: 18 },
    { symbol: 'SQQQB', address: '0x25e572B466D152604D9E6C3e53B432B978825342', decimals: 18 },
    { symbol: 'SMCIB', address: '0x387dEa1D2772D716d081A29116f3EfFA0fFE1F36', decimals: 18 },
    { symbol: 'IRENB', address: '0xfdc2F2caB77b28f7Ef6c819A404706cfA9bCA33b', decimals: 18 },
    { symbol: 'ASMLB', address: '0xFbfB4f79cFB4C34DCd7C82Bdee5A0Fa199B2e7f9', decimals: 18 },
    { symbol: 'ASTSB', address: '0x58b6F5fEeb8436489F5bf4a56619092B1FA8E777', decimals: 18 },
    { symbol: 'COHRB', address: '0x5131859a059B2446AbeeFe0f5d313b3c54Ff3D36', decimals: 18 },
    { symbol: 'CRDOB', address: '0x6E7D451F9D30327D32020f116Fa79C23B24E9c8D', decimals: 18 },
    { symbol: 'USARB', address: '0xcd345D4450e04cDeF422A60b97D9265d24e0bcEE', decimals: 18 },
    { symbol: 'ALABB', address: '0x1282493ede6a22753d45cb2c0fdbd8d35e97555a', decimals: 18 },
    { symbol: 'CRCLB', address: '0x80f3D493EBCe97e343c53D29a137942416B4ffC0', decimals: 18 },
    { symbol: 'CRCLB', address: '0xcdf2f3e0fa43C47A6662a91C9E4a7C5f69762699', decimals: 18 },
    { symbol: 'SNDKB', address: '0x3ee4df61bd4f867e349beae8bfe07bc31b4850fb', decimals: 18 },
    { symbol: 'AMDB', address: '0x75fd4cf6f8392e41e70391d60c90c0d5211603a1', decimals: 18 },
    { symbol: 'EWYB', address: '0xbe82f76637dba2c114c41df856c2c51e522e2cb8', decimals: 18 },
    { symbol: 'INTCB', address: '0xe614e2fc6c787035ff51f452e8e826bfd32d5283', decimals: 18 },
    { symbol: 'LITEB', address: '0x64748BeA17b6D19e242ADf20425DE2440c656142', decimals: 18 },
    { symbol: 'METAB', address: '0x7425889FE94F9d693E8daefE88BCCed6AcFEf4c0', decimals: 18 },
    { symbol: 'PLTRB', address: '0x0Ca5D51D0277Bd006fd9607d3E560785EBad8222', decimals: 18 },
    { symbol: 'BEB', address: '0x5519de00F5388c17d886b97Cb5D2D43a812a82bC', decimals: 18 },
    { symbol: 'AMZNB', address: '0x1a4b499833A79A09ad7Cf1D42D7DacF71e92eb00', decimals: 18 },
    { symbol: 'DELLB', address: '0x0e7A51966c66648999d506e1372EFDeA1B78cb0B', decimals: 18 },
    { symbol: 'AMATB', address: '0xa304BD78e739C0F777202B3eB73Ac3736d1df801', decimals: 18 },
    { symbol: 'PYPLB', address: '0x2806a561fC1F9259B2d54A281796Bde0D92762aE', decimals: 18 },
    { symbol: 'GSB', address: '0x20CCe6656E5F7F79f280E2D0F5dB55b401BDbfCe', decimals: 18 },
    { symbol: 'SMHB', address: '0xBE1fceD7047fdCE935F45700727845df2c76877a', decimals: 18 },
    { symbol: 'QCOMB', address: '0x5F7A56e877B9130608Bf8BE962621011182fEfE1', decimals: 18 },
    { symbol: 'COINB', address: '0x585BDE7C54ABB5cCD7791F923D6c2187635f3952', decimals: 18 },
    { symbol: 'WDCB', address: '0xebe29695F8047C13d36e7a790ca8c1b239FfAD1C', decimals: 18 },
    { symbol: 'GLWB', address: '0x740e075cBbEa22a082B9d6679e65e82767875b6A', decimals: 18 },
    { symbol: 'NBISB', address: '0xE256BC2A4F5297F8ba6f043F180a46300eCbCbB1', decimals: 18 },
    { symbol: 'DRAMB', address: '0x93862d63fd9Fd488B1328E9b47717d75e994a84B', decimals: 18 },
    { symbol: 'CBRSB', address: '0xe81C6bB0266cd68B4F17278531Dd03eA1F12dA4E', decimals: 18 },
    { symbol: 'ARMB', address: '0xd42a79ebb7f527f40faecd196ffb47ad5e8d6f8c', decimals: 18 },
    { symbol: 'AAOIB', address: '0x10343ef7da3301493d7ecb647d68a288c6c1db2f', decimals: 18 },
    { symbol: 'RKLBB', address: '0xc8da12cbcce7c45180692a6420b0076e03a5179a', decimals: 18 },
    { symbol: 'NOKB', address: '0x7c4d7a180d737dd5a70d8065a90e6746a69c37ea', decimals: 18 },
    { symbol: 'TSMB', address: '0xab78b89b5bb00236be0b4b20704cbfa04efc711c', decimals: 18 },
    { symbol: 'AVGOB', address: '0x76682c454467b3a1150ad8b6a92fc5ee2c21d7ed', decimals: 18 },
    { symbol: 'MRVLB', address: '0x16cd4fe7e8880ecc3ba222795229e20489fc2c76', decimals: 18 },
    { symbol: 'IBMB', address: '0xfa273b076feb8c0fb34e554ae341082323d016a3', decimals: 18 },
    { symbol: 'KORUB', address: '0x1ffad32d69c5fead99f88c25ca0191edc3757636', decimals: 18 },
    { symbol: 'AXTIB', address: '0x9bdc8b470dbf89dbcb123587c6f5e49cca3463be', decimals: 18 },
    { symbol: 'CRWVB', address: '0x33e7317e17838fee56b10fe8d0b9ca6ca3090c95', decimals: 18 },
    { symbol: 'MUUB', address: '0x0bb3fa77e0809f42948e435f04883c25415e8263', decimals: 18 },
    { symbol: 'MVLLB', address: '0x7c26a12f20507e2cee22ceebed9e88fda47f866c', decimals: 18 },
    { symbol: 'SNXXB', address: '0x9e82e3da8f1115b73d24bb24113ab836ffdab6b6', decimals: 18 },
    { symbol: 'INTWB', address: '0x0735d9904b7e34e6fe39b0f66e00c111b3f2b681', decimals: 18 },
    { symbol: 'TQQQB', address: '0x462b5f13b7c7748279358962925c5de83bb9e598', decimals: 18 },
    { symbol: 'QNTB', address: '0xd721c192d612db77621df57a9fab38418033c02e', decimals: 18 },
    { symbol: 'ORCLB', address: '0x4684d9887fc1c71cba7bab8e88835cec217eb598', decimals: 18 },
    { symbol: 'STXB', address: '0x2E065f65F1699964f4092De1D39A8EFe6C8d6f32', decimals: 18 },
    { symbol: 'CRWDB', address: '0x814981cf5df4a14d4d7328f9abf0d02e9ed54cd1', decimals: 18 },
];
export const styles = `
  .token-selector-wrapper {
    position: relative;
    width: 100%;
    text-align: left;
  }

  /* ========== 触发器 ========== */
  .token-trigger {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 13px 6px;
    background: #ffffff;
    border: 1.5px solid #e9edf2;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  }
  .token-trigger:hover {
    border-color: #c7e8e3;
    background: #fcffff;
    box-shadow: 0 6px 16px -6px rgba(20, 184, 166, 0.15);
  }
  .trigger-content {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .placeholder {
    color: #94a3b8;
    font-size: 14px;
    font-weight: 400;
  }
  .arrow-icon {
    font-size: 10px;
    color: #94a3b8;
    transition: transform 0.25s cubic-bezier(0.2, 0.9, 0.4, 1), color 0.2s;
    line-height: 1;
  }
  .arrow-icon.open {
    transform: rotate(180deg);
    color: #14b8a6;
  }

  /* ========== 下拉框 ========== */
  .token-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    width: 100%;
    background: #ffffff;
    border: 1px solid #f1f5f9;
    border-radius: 20px;
    box-shadow: 0 24px 48px -16px rgba(0, 0, 0, 0.18), 0 8px 20px -10px rgba(0, 0, 0, 0.06);
    z-index: 100;
    overflow: hidden;
    color: #0f172a;
  }

  /* ========== 搜索区域 ========== */
  .dropdown-search {
    position: relative;
    padding: 14px 16px 10px;
    border-bottom: 1px solid #f1f5f9;
  }
 
  .dropdown-search input {
    width: 100%;
    background: #f8fafc;
    border: 1px solid #e9edf2;
    border-radius: 14px;
    padding: 10px 36px 10px 38px;
    color: #0f172a;
    font-size: 13px;
    outline: none;
    box-sizing: border-box;
    transition: all 0.2s;
    font-weight: 400;
  }
  .dropdown-search input::placeholder {
    color: #a0aec0;
    font-size: 12.5px;
  }
  .dropdown-search input:focus {
    border-color: #14b8a6;
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.12);
  }

  /* ========== Tab 标签 ========== */
  .dropdown-tabs {
    display: flex;
    gap: 8px;
    padding: 12px 16px 8px;
  }
  .tab-btn {
    padding: 6px 18px;
    border-radius: 40px;
    font-size: 12.5px;
    font-weight: 500;
    border: 1px solid #e9edf2;
    cursor: pointer;
    background: #ffffff;
    color: #64748b;
    transition: all 0.2s ease;
    outline: none;
    line-height: 1.4;
  }
  .tab-btn:hover {
    background: #f8fafc;
    color: #14b8a6;
    border-color: #c7e8e3;
  }
  .tab-btn.active {
    background: #14b8a6;
    border-color: #14b8a6;
    color: #ffffff;
    box-shadow: 0 4px 12px -4px rgba(20, 184, 166, 0.5);
  }

  /* ========== 列表容器 ========== */
  .dropdown-list {
    max-height: 260px;
    overflow-y: auto;
    padding: 8px 12px 12px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(92px, 1fr));
    gap: 8px;
  }

  /* ========== 代币条目 ========== */
  .token-item {
    display: flex;
    align-items: center;
    padding: 9px 10px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.18s ease;
    border: 1.5px solid transparent;
    background: #f8fafc;
    position: relative;
    min-width: 0;
  }
  .token-item:hover {
    background: #f0fdfa;
    border-color: #d5f0eb;
  }
  .token-item.selected {
    background: #f0fdfa;
    border-color: #14b8a6;
    box-shadow: 0 0 0 2px rgba(20, 184, 166, 0.15);
  }
  .token-item.chain-result {
    grid-column: 1 / -1;
    background: #f0fdfa;
    border-color: #14b8a6;
    padding: 10px 12px;
  }

  .token-info {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-width: 0;
    overflow: hidden;
  }
  .token-icon-box {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: #eef2f6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    flex-shrink: 0;
  }
  .token-text {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 0;
    flex: 1;
  }
  .token-item-symbol {
    font-size: 12.5px;
    font-weight: 600;
    color: #0f172a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: -0.01em;
  }
  .token-item-address {
    font-size: 10px;
    color: #94a3b8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    margin-top: 1px;
  }

  /* 选中角标 */
  .check-icon {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 14px;
    height: 14px;
    background: #14b8a6;
    color: #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    font-weight: 700;
    line-height: 1;
    box-shadow: 0 2px 6px -2px rgba(20, 184, 166, 0.5);
  }

  /* ========== 空状态 & 查询中 ========== */
  .empty-state {
    text-align: center;
    padding: 36px 16px;
    color: #a0aec0;
    font-size: 13px;
    grid-column: 1 / -1;
    font-weight: 400;
  }
  .empty-state::before {
    content: '🔎';
    display: block;
    font-size: 22px;
    margin-bottom: 10px;
    opacity: 0.6;
  }

  /* ========== 滚动条 ========== */
  .dropdown-list::-webkit-scrollbar {
    width: 5px;
  }
  .dropdown-list::-webkit-scrollbar-track {
    background: transparent;
  }
  .dropdown-list::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 10px;
  }
  .dropdown-list::-webkit-scrollbar-thumb:hover {
    background: #cbd5e1;
  }
`;